var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.229 17.6951C7.229 15.6542 11.8721 13.9984 17.6016 13.9984C23.3295 13.9984 27.9726 15.6543 27.9726 17.6951V21.0927C27.9726 23.1335 23.3295 24.7894 17.6016 24.7894C11.8721 24.7894 7.229 23.1335 7.229 21.0927V17.6951Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6017 13.9984C23.3296 13.9984 27.9727 15.6543 27.9727 17.6951C27.9727 19.7374 23.3296 21.3917 17.6017 21.3917C11.8722 21.3917 7.22913 19.7375 7.22913 17.6951C7.22907 15.6542 11.8722 13.9984 17.6017 13.9984Z",
    fill: "#FECD3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6017 15.7258C22.1589 15.7258 25.8524 16.6086 25.8524 17.6951C25.8524 18.7831 22.1589 19.6643 17.6017 19.6643C13.0444 19.6643 9.34937 18.783 9.34937 17.6951C9.34937 16.6086 13.0444 15.7258 17.6017 15.7258Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.3509 22.7231L13.2369 22.7247V24.4458C12.9404 24.3974 12.645 24.3423 12.3509 24.2803V22.7231ZM25.1683 21.8117V23.6202C25.488 23.4977 25.7839 23.369 26.0559 23.2337V21.8101L25.1683 21.8117ZM15.5545 24.7162C15.8472 24.7384 16.143 24.7544 16.442 24.7655V23.1208L15.5545 23.1224V24.7162ZM9.14575 23.2337C9.41777 23.369 9.71363 23.4977 10.0333 23.6202V21.8101L9.14575 21.8117V23.2337ZM18.7596 24.7655C19.0552 24.7541 19.3506 24.7376 19.6456 24.7162V23.1224L18.7596 23.1208V24.7655ZM21.9648 24.4458C22.2614 24.3976 22.5568 24.3424 22.8508 24.2803V22.7247L21.9648 22.7231V24.4458Z",
    fill: "#C85929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.07266 21.8021V22.9029H4.17182V23.6886H3.07266V24.7894H2.28691V23.6886H1.18616V22.9029H2.28691V21.8021H3.07266ZM23.1816 9.74664V10.8473H24.2823V11.6316H23.1816V12.7322H22.3958V11.6316H21.2967V10.8473H22.3958V9.74664H23.1816ZM3.60077 3.21066V4.31141H4.69994V5.09558H3.60077V6.19633H2.81497V5.09558H1.71427V4.31141H2.81497V3.21066H3.60077Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.217486 15.7736C-0.803694 14.0048 2.39033 10.2493 7.35152 7.38611C12.3128 4.52136 17.161 3.63378 18.1822 5.40096C18.7481 6.38152 19.3144 7.36188 19.881 8.34205C20.9022 10.1109 17.7082 13.8664 12.747 16.7295C7.7858 19.5943 2.93748 20.4834 1.9163 18.7146C1.35001 17.7348 0.783775 16.7534 0.217486 15.7736Z",
    fill: "#FE9923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35152 7.38611C12.3128 4.52136 17.161 3.63378 18.1822 5.40096C19.2034 7.16977 16.0094 10.9253 11.0482 13.7884C6.08857 16.6532 1.23867 17.5408 0.217486 15.7735C-0.803694 14.0048 2.39033 10.2493 7.35152 7.38611Z",
    fill: "#FECD3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21531 8.88133C12.1617 6.60354 15.8027 5.52029 16.3467 6.46195C16.8907 7.40362 14.1309 10.0138 10.1846 12.2933C6.23814 14.5711 2.59875 15.6543 2.05477 14.7127C1.51079 13.771 4.2689 11.1607 8.21531 8.88133Z",
    fill: "#FEA832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.9098 15.8658L11.7322 17.2895C11.4701 17.4278 11.2054 17.5614 10.9385 17.6903L10.1416 16.3096L10.9098 15.8658ZM3.9364 18.379L4.64745 19.6102C4.94965 19.5927 5.271 19.5561 5.6082 19.502L4.70471 17.9353L3.9364 18.379ZM7.16701 17.5662L7.94642 18.9151C8.23172 18.8217 8.51493 18.722 8.79582 18.6161L7.93526 17.124L7.16701 17.5662ZM12.9172 14.7062L13.7396 16.1299C13.9899 15.9724 14.2376 15.8107 14.4824 15.6447L13.6855 14.2656L12.9172 14.7062ZM18.5799 9.92316L17.8116 10.3685L18.7167 11.9337C18.9314 11.6697 19.1239 11.4088 19.2909 11.1559L18.5799 9.92316ZM15.4941 12.7593L16.3546 14.2513C16.5873 14.0618 16.8154 13.8666 17.0386 13.666L16.2608 12.3187L15.4941 12.7593Z",
    fill: "#C85929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsTab);
export default __webpack_public_path__ + "static/media/rewardsTab.73b699eb01c02fcbaaa3fa96b8aece6c.svg";
export { ForwardRef as ReactComponent };